
export function isAppleDevice(): boolean {
    const userAgent = navigator.userAgent
    return /iPhone|iPad|iPod/i.test(userAgent) ||
        (/Safari/i.test(userAgent) && /Macintosh/i.test(userAgent) && !/Chrome|Firefox|Edge/i.test(userAgent))
}